import React from "react";
import UserProfileMenu from "../components/menu/user/UserProfileMenu";

const UserProfile = () => {
  return <UserProfileMenu />;
};
export default UserProfile;
